import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function CTASection() {
  return <section id="agenda" className="py-24 px-6 bg-gold text-navy" data-id="element-22">
      <div className="max-w-4xl mx-auto text-center" data-id="element-23">
        <FadeIn data-id="element-24">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-25">
            Si sientes que llegaste a tu techo, es momento de construir
            diferente.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-26">
          <p className="text-xl md:text-2xl font-medium mb-10 max-w-3xl mx-auto" data-id="element-27">
            Si tu operación está desordenada, o si simplemente sabes que tu
            negocio puede dar más de lo que está dando hoy — este es el
            siguiente paso.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-28">
          <div className="flex flex-col gap-5 mb-12 max-w-xl mx-auto" data-id="element-29">
            {['Entendemos cómo está construida tu operación hoy', 'Identificamos qué está frenando el siguiente nivel', 'Te damos claridad estratégica sobre qué cambiar y por dónde empezar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-30">
                <div className="w-6 h-6 rounded-full bg-navy flex items-center justify-center shrink-0" data-id="element-31">
                  <Check className="w-4 h-4 text-gold" data-id="element-32" />
                </div>
                <span className="font-semibold text-lg text-left" data-id="element-33">{item}</span>
              </div>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-34">
          <div className="flex flex-col items-center gap-4" data-id="element-35">
            <a href="https://wa.me/17866035862?text=Hola%20Oscar%2C%20quiero%20agendar%20un%20diagn%C3%B3stico%20estrat%C3%A9gico" target="_blank" rel="noopener noreferrer" className="inline-block bg-navy hover:bg-[#252540] text-white hover:text-gold font-bold text-xl px-10 py-5 rounded transition-all duration-300 hover:scale-105 shadow-xl" data-id="element-36">
              Agenda un diagnóstico estratégico
            </a>
            <p className="text-sm font-medium opacity-80 max-w-md mt-2 italic" data-id="element-37">
              Solo para dueños de negocio con operación activa que quieren
              crecer con estructura.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}